import {TransformInteractionState} from "../abstract-transform";
import {EditorPointTransformTranslate} from "../editor/editor-point-transform-translate";
import {ViewSimpleSelect} from "../view/view-simple-select";
import {Feature, GeoJSON, Position} from "geojson";
import {MapEvent} from "../../../document/model/map";
import {GeometryUtil} from "../../geometry";
import { } from "geojson";

export class GeoreferencerDrawPoint extends EditorPointTransformTranslate {

  private tmpPoints: Position[];

  buildInitialState(initialState: DrawInteractionState): InteractionState {
    this.aim = this.createAIM(undefined, undefined, undefined, 'aim1');
    return super.buildInitialState(initialState);
  }



  showHistory(state: TransformInteractionState): boolean {
    return false;
  }


  canSave(state: TransformInteractionState): boolean {
    return false;
  }

  display(state: TransformInteractionState, geojson: GeoJSON & Feature, display: (geojson: GeoJSON) => void): any {
    ViewSimpleSelect.prototype.display.apply(this, arguments);
  }

  async onMouseMove(state: DrawInteractionState, e: mapboxgl.MapMouseEvent) {
    this.snapPoint = this.controller.snapUtility.getSnapPoint(e);
    this.aim.geometry.coordinates = this.snapPoint.point as Position;
    this.displayDrawFeature(this.aim);
  }

  getCoordinates(state: DrawInteractionState): {path: string; coordinate: Position}[] {
    if (this.controller.interaction.hasManualInputDialog()) {
      return state.tmpPoints?.map((coordinate, index) => {
        return {path: `0.${index}`, coordinate};
      }) || []
    }
    else return super.getCoordinates(state);
  }

  save(state: any, nextInteraction: string | undefined = undefined) {
    if (this.controller.interaction.hasManualInputDialog()) {
      this.controller.mapInstance.fire(MapEvent.TmpPinAdd, {features: state.tmpPoints})
    }
    //else super.save(state, nextInteraction)
  }


  async setCoordinates(state: DrawInteractionState, points: Position[]): Promise<void> {
    if (this.controller.interaction.hasManualInputDialog()) {
      this.clearDrawFeatures();
      state.tmpPoints = [...points];
      this._generateManualInputPoints(state)
    }
    //else super.setCoordinates(state, points)
  }

  async onClick(state: any, e: MapboxDraw.MapMouseEvent): Promise<void> {
    let snapPoint = this.controller.snapUtility.getSnapPoint(e);
    if (this.controller.interaction.hasManualInputDialog()) {
      if (!state.tmpPoints) state.tmpPoints = []
      state.tmpPoints.push(snapPoint.point)
      this._generateManualInputPoints(state);
    }
    else {
      this.controller.interaction.clearTmpGeometries();
      let newAim = this.createAIM(undefined, snapPoint.point as Position, (new Date()).getTime());
      this.displayDrawFeature(newAim);
      this.controller.mapInstance.fire(MapEvent.PinAdd, {feature: (newAim.toGeoJSON() as Feature)});
    }
  }

  _generateManualInputPoints(state: DrawInteractionState): void {
    state.tmpPoints?.forEach((point: Position, index) => {
      let p = this.createIcon(point, 'auto-aim', {
        id: `tmp_point_${index}`
      });
      this.displayDrawFeature(p);
    })
    this.tick();
  }
}
